/**
 * How a posting reaches a Radar digest, as a sequence. The message to get
 * first: it is watched at the source and arrives once. Four steps, one
 * emphasis (the digest), real text throughout; the cadence figures come from
 * the crawler's own constants (HOT_INTERVAL_HOURS = 2, COLD = 24) rather
 * than a promise. Night ground, so the white ramp.
 */
const STEPS = [
  { k: "posted", title: "Company posts", body: "on its own career page" },
  { k: "swept", title: "Radar reads it", body: "every 2 hours while a board is changing; daily when quiet" },
  { k: "dedup", title: "Deduplicated", body: "the same role never reaches you twice" },
  { k: "digest", title: "One digest", body: "only what is new, on your schedule", emphasis: true },
];

export default function RadarTimeline() {
  return (
    <figure data-testid="radar-timeline">
      <ol className="grid grid-cols-2 sm:grid-cols-4 gap-x-3 gap-y-5">
        {STEPS.map((s, i) => (
          <li key={s.k} className="relative min-w-0" data-testid={`radar-step-${s.k}`}>
            {/* The connector: a hairline into the next step, hidden on the last. */}
            {i < STEPS.length - 1 && (
              <span aria-hidden="true" className="hidden sm:block absolute top-[11px] left-[26px] right-[-6px] h-px bg-white/15" />
            )}
            <span
              aria-hidden="true"
              className={`relative z-10 inline-grid place-items-center w-[22px] h-[22px] rounded-full font-mono text-[10px] font-bold ${
                s.emphasis ? "bg-brand text-white ring-4 ring-brand/25" : "bg-white/10 text-white/80 border border-white/20"
              }`}
            >
              {i + 1}
            </span>
            <div className={`mt-2.5 text-[13px] font-medium ${s.emphasis ? "text-white" : "text-white/85"}`}>{s.title}</div>
            <div className="mt-0.5 text-[11px] leading-snug text-white/55">{s.body}</div>
          </li>
        ))}
      </ol>
      <figcaption className="sr-only">
        A company posts on its own career page; Radar reads it every 2 hours while the board is changing and daily when it is quiet;
        duplicates are removed so the same role never reaches you twice; you get one digest of only what is new, on your schedule.
      </figcaption>
    </figure>
  );
}
